export class InputOutputDimmerParameters {
    constructor() {
        this.Channel = 0;
        this.InputModeDimmer = InputModeDimmer.Monostable;
    }
}
export var InputModeDimmer;
(function (InputModeDimmer) {
    InputModeDimmer[InputModeDimmer["Monostable"] = 0] = "Monostable";
    InputModeDimmer[InputModeDimmer["Time"] = 1] = "Time";
    InputModeDimmer[InputModeDimmer["Bistable"] = 2] = "Bistable";
})(InputModeDimmer || (InputModeDimmer = {}));
//# sourceMappingURL=Rdp21ConfigParameters.js.map